module.exports = __webpack_public_path__ + "img/puck-exploded-view-v01.ba047f24.png";